import { useState } from "react";
import { useStudentAuth } from "./auth/StudentAuthContext.js";

export default function StudentLoginPage() {
  const auth = useStudentAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [newPw, setNewPw] = useState("");
  const [code, setCode] = useState("");
  const [resetPw, setResetPw] = useState("");

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="llogo"><img className="brandmark" src="/mizpah-logo.jpg" alt="Mizpah Center for Allied Health Education" /> Mizpah Student Portal</div>

        {auth.status === "signedOut" && (
          <form onSubmit={(e) => { e.preventDefault(); auth.signIn(email.trim(), password); }}>
            <h1>Student sign in</h1>
            <p className="sub">Use the email and temporary password from your welcome message.</p>
            {auth.notice && <div className="login-note" role="status">{auth.notice}</div>}
            <label>Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" />
            <label>Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
            <button className="login-btn" type="submit">Sign in</button>
            <button type="button" className="login-link" onClick={() => auth.startForgot()}>Forgot password?</button>
          </form>
        )}

        {auth.status === "newPassword" && (
          <form onSubmit={(e) => { e.preventDefault(); auth.completeNewPassword(newPw); }}>
            <h1>Set your password</h1>
            <p className="sub">First sign-in - choose a password (10+ characters, with upper- and lower-case letters and a number).</p>
            <label>New password</label>
            <input type="password" value={newPw} onChange={(e) => setNewPw(e.target.value)} autoComplete="new-password" />
            <button className="login-btn" type="submit">Continue</button>
          </form>
        )}

        {auth.status === "forgot" && (
          <form onSubmit={(e) => { e.preventDefault(); auth.requestReset(email.trim()); }}>
            <h1>Reset your password</h1>
            <p className="sub">Enter your email and we'll send a reset code.</p>
            <label>Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" />
            <button className="login-btn" type="submit">Send reset code</button>
            <button type="button" className="login-link" onClick={() => auth.backToSignIn()}>Back to sign in</button>
          </form>
        )}

        {auth.status === "reset" && (
          <form onSubmit={(e) => { e.preventDefault(); auth.confirmReset(code, resetPw); }}>
            <h1>Enter your reset code</h1>
            <p className="sub">We emailed a code to {auth.email || "your email"}. Enter it with a new password (10+ characters, with upper- and lower-case letters and a number).</p>
            <label>Reset code</label>
            <input value={code} onChange={(e) => setCode(e.target.value)} inputMode="numeric" autoComplete="one-time-code" />
            <label>New password</label>
            <input type="password" value={resetPw} onChange={(e) => setResetPw(e.target.value)} autoComplete="new-password" />
            <button className="login-btn" type="submit">Change password</button>
            <button type="button" className="login-link" onClick={() => auth.backToSignIn()}>Back to sign in</button>
          </form>
        )}

        {auth.error && <div className="login-err" role="alert">{auth.error}</div>}
      </div>
    </div>
  );
}
